type PublishingMessage = {
	readonly message: string;
	readonly additionalMessage: string | null | undefined;
};

export type PublishingFailure = {
	contentsFailed: boolean;
	details: string[];
};

const CONTENT_ERROR_MESSAGE = "error-publishing-content";

export const getPublishingFailure = (messages: readonly PublishingMessage[]): PublishingFailure => {
	const contentErrors = messages
		.filter((m) => m.message === CONTENT_ERROR_MESSAGE)
		.map((m) => m.additionalMessage)
		.filter((m): m is string => !!m);

	if (contentErrors.length > 0) return { contentsFailed: true, details: contentErrors };

	const lastMessage = messages[messages.length - 1];
	const lastDetail = lastMessage?.additionalMessage ?? lastMessage?.message;

	return { contentsFailed: false, details: lastDetail ? [lastDetail] : [] };
};
